import React from "react";

function Logo({ variant = "dark" }) {
  return (
    <div className={`logo logo--${variant}`} aria-label="Fashion Factory">
      <img
        src={`${process.env.PUBLIC_URL}/logo-main.png`}
        alt="Fashion Factory — Brands for less"
        className="logo__img"
      />
    </div>
  );
}

export default Logo;
